module.exports = __webpack_public_path__ + "img/bonteous_slide_3.dd15b023.jpg";